import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=280af2b3&scoped=true&"
import script from "./Card.ts?vue&type=script&lang=ts&"
export * from "./Card.ts?vue&type=script&lang=ts&"
import style0 from "./Card.scss?vue&type=style&index=0&id=280af2b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280af2b3",
  null
  
)

export default component.exports